export const ES_FILTERS_API_NAMES = {
  tbl_source: "parent_name.raw",
  col_source: "source_name.raw",
  tbl_data_domain:
    "classifications.functional_area.value.functional_area_name.raw",
  col_data_domain: "functional_area_name.raw",
  trm_data_domain: "domain_name.raw",
};
